import { AlertTriangle } from 'lucide-react';

export function RepeatReviewWarning({ count, compact = false, userConfirmed = false }: { count: unknown; compact?: boolean; userConfirmed?: boolean }) {
  const previous = Number(count);
  if (!Number.isInteger(previous) || previous <= 0) return null;
  return <div role="note" className="readiness readiness--warning" data-testid="repeat-place-review-warning">
    <AlertTriangle aria-hidden="true" />
    <div><strong>เคยรีวิวร้านนี้แล้ว {previous} ครั้ง</strong>{!compact && userConfirmed && <p>ผู้ใช้ยืนยันส่งรีวิวร้านเดิมในแคมเปญนี้แล้ว</p>}{!compact && <p>Admin กรุณาตรวจสอบซ้ำก่อนอนุมัติรางวัล</p>}</div>
  </div>;
}
